import { shape, string, number } from 'prop-types';

const periodPropTypes = shape({
  periodGuid: string.isRequired,
  periodName: string.isRequired,
  startDate: number.isRequired,
  endDate: number.isRequired,
  currency: string.isRequired,
  deposit: number,
  costOfAttendance: number.isRequired,
  costOfLiving: number.isRequired,
  costOfTuition: number.isRequired,
  classId: string.isRequired,
});

export default periodPropTypes;
